export enum A48SubmissionContextCode {
    NONE = 0,
    EMERGENCY_CERT_SUBMISSION = 1
}